// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"ee3d81a1","315":"a65f3e1b","688":"f473b907","837":"9a5ca785","881":"8d48f6a3"}[chunkId] + ".chunk.js";
};